import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { logout } from '../../../../../../services/authorization/actions'

function mapDispatchToProps(dispatch) {
    return {
        logoutAction: bindActionCreators(logout, dispatch),
    }
}

export default function (InnerComponent) {
    @connect(null, mapDispatchToProps)
    class HocConnect extends Component {
        render() {
            return <InnerComponent {...this.props} />
        }
    }

    return HocConnect
}
